var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProjectsWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41663 18C5.27288 18 4.17598 17.5259 3.36723 16.682C2.55848 15.8381 2.10413 14.6935 2.10413 13.5C2.10413 12.3065 2.55848 11.1619 3.36723 10.318C4.17598 9.47412 5.27288 9.00001 6.41663 9.00001C6.68675 7.68719 7.47699 6.5335 8.6135 5.79273C9.17624 5.42594 9.80705 5.17156 10.4699 5.04412C11.1328 4.91669 11.8147 4.91869 12.4768 5.05001C13.1389 5.18133 13.7681 5.43941 14.3286 5.80949C14.8891 6.17958 15.3699 6.65443 15.7435 7.20694C16.1171 7.75945 16.3762 8.37879 16.506 9.02961C16.6358 9.68043 16.6337 10.35 16.5 11H17.4166C18.2675 11 19.0836 11.3688 19.6853 12.0251C20.2869 12.6815 20.625 13.5718 20.625 14.5C20.625 15.4283 20.2869 16.3185 19.6853 16.9749C19.0836 17.6313 18.2675 18 17.4166 18H6.41663Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjectsWhite);
export default __webpack_public_path__ + "static/media/Icon_Projects_White.8b6deb2109a0ee9211c3cdb40a07a4af.svg";
export { ForwardRef as ReactComponent };